// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2YyBA","examples_link":"App_examples_link__21wyH"};